// Prevents the submit event from bubbling up to the parent.
export default function withStopPropagation(callback) {
  return function(event) {
    event.stopPropagation();
    return callback(event);
  };
}